// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2HKFI","header":"PatientQuestionnaire_header__3r4Jy","info":"PatientQuestionnaire_info__1GLXy"};